import { Box, Button, Checkbox, Popover, Typography } from '@mui/material'
import React, { useState } from 'react'
import { headingBlue, maroon, pureWhite } from '../../../assets/colors'
import { buttonStyle } from '../../../utils/commonCSS';

const WORKersFilters = (props) => {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const open = Boolean(anchorEl);

	
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};


	const handleClose = () => {
		setAnchorEl(null);
	};

	var typographyStyle = {
			fontSize: "1rem",
			color: maroon,
			padding: "0.1rem",
		};


  return (
    <>
    <Button
				variant="contained"
				aria-describedby="filter-button"
				// aria-controls={open ? 'basic-menu' : undefined}
				// aria-haspopup="true"
				// aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
				sx={{
					backgroundColor: pureWhite,
					color: headingBlue,
					padding: "0.2rem 0.5rem 0.2rem 0.5rem",
				}}
			>
				Filters
			</Button>

      <Popover id="filter-button"
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				style={{marginTop: '0.2rem'}}
				>
					<Box style={{padding: '0.2rem 0rem 0.5rem 0rem'}}>
						<Box sx={{
							display: "flex",
							flexDirection: "column",
							width: "320px",
							maxHeight: "90vh",
							overflowY: "auto",
							scrollbarWidth: "none",
							marginTop: "0.2rem",
							height: '55vh'
						}}>
							<Box p={18} sx={{ padding: "1rem 1rem 1rem 1rem" }} >
								<Typography style={typographyStyle}>
									Gender
								</Typography>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.maleFilter} onClick={() => props.updateMaleFilter(!props.maleFilter)} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>Male</Typography>
								</Box>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.femaleFilter} onClick={() => {props.updateFemaleFilter(!props.femaleFilter)}} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>Female</Typography>
								</Box>

							</Box>


							<Box p={18} sx={{ padding: "1rem 1rem 1rem 1rem" }}>
								<Typography style={typographyStyle}>
									Obligation
								</Typography>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.oblAllFilter} onClick={() => props.updateOblAllFilter(!props.oblAllFilter)} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>All</Typography>
								</Box>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.oblSHFilter} onClick={() => {props.updateOblSHFilter(!props.oblSHFilter)}} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>State Head</Typography>
								</Box>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.oblDHFilter} onClick={() => {props.updateOblDHFilter(!props.oblDHFilter)}} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>District Head</Typography>
								</Box>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.oblWORKerFilter} onClick={() => {props.updateOblWORKerFilter(!props.oblWORKerFilter)}} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>WORkers</Typography>
								</Box>

							</Box>

							<Box p={18} sx={{ padding: "1rem 1rem 1rem 1rem" }}>
								<Typography style={typographyStyle}>
									Membership Card Status
								</Typography>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.mCardGFilter} onClick={() => props.updateMCardGFilter(!props.mCardGFilter)} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>Generated</Typography>
								</Box>
								<Box style={{display: 'flex', flexDirection: 'row'}}>
									<Checkbox checked={props.mCardNGFilter} onClick={() => {props.updateMCardNGFilter(!props.mCardNGFilter)}} sx={{padding: '0rem'}}></Checkbox>
									<Typography style={{marginLeft: '0.3rem'}}>Not Generated</Typography>
								</Box>

							</Box>

						</Box>

						<Box style={{padding: '1rem 0.5rem 0rem 0rem', display: 'flex', justifyContent: 'right'}}>
							<Button style={{...buttonStyle, fontSize: '0.9rem', padding: '0.1rem 0.3rem 0.1rem 0.3rem'}} onClick={(event) => {
								props.updateRefreshApi()
								handleClose()
							}}> Apply Filters</Button>
						</Box>
					</Box>

            </Popover>
    </>
  )
}

export default WORKersFilters